import { ReportRequest } from '@/client/reports';
import {
  TotalVulnerableUsers,
  VulnerableUsersList,
} from '@/components/campaigns/analytics';
import { useVulnerableUsersReports } from '@/hooks/query';
import { useAppSelector } from '@/hooks/store';
import { useTable } from '@/hooks/table.hook';
import { selectCurrentAccount } from '@/store/features/account';
import { FlexContainer } from '@/ui/styled-ui';
import React from 'react';

type PhishingVulnerableAnalysisProps = {
  filters: ReportRequest;
};

export const PhishingVulnerableAnalysis = ({
  filters,
}: PhishingVulnerableAnalysisProps) => {
  const account = useAppSelector(selectCurrentAccount);
  const { onSort, sort, skip, take, onPage } = useTable();

  const { isLoading, vulnerableUsers, isFetching, total } =
    useVulnerableUsersReports(account?.id as string, {
      ...filters,
      skip,
      take,
      sort: sort && sort?.length > 0 ? [sort.join(',')] : [],
    });

  return (
    <FlexContainer
      direction="column"
      align="stretch"
      justify="space-between"
      gap={24}
      className="mt-4"
    >
      {/* TODO: uncomment when we have enough data in the DB */}
      {/* <VulnerableUsersOverview filters={filters} /> */}
      <TotalVulnerableUsers
        vulnerableUsersCount={total || 0}
        isLoading={isLoading}
      />
      <VulnerableUsersList
        vulnerableUsers={vulnerableUsers}
        isLoading={isLoading}
        isFetching={isFetching}
        onSort={onSort}
        sort={sort}
        rows={take}
        skip={skip}
        onPage={onPage}
        total={total}
      />
    </FlexContainer>
  );
};
